import { parseISO } from 'date-fns';
import { chartColors } from '~/pages/VendorDashboard/charts/chartColors';
import { formatShortMonthUSDate } from '~/utils/date-formatting';
export const SERIES_COLOR_RAMP = [
    chartColors.blue,
    chartColors.lightBlue,
    chartColors.green,
    chartColors.red,
    chartColors.lightRed,
    chartColors.lightGray
];
const VALID_CHART_TYPES = [
    'bar',
    'line',
    'area',
    'pie'
];
const isDataRow = (row)=>row != null && typeof row === 'object';
const seriesKeyInData = (key, data)=>data.some((row)=>isDataRow(row) && key in row);
export const isRenderableChartSpec = (spec)=>{
    var _spec_x;
    if (!VALID_CHART_TYPES.includes(spec.chart_type)) return false;
    if (!((_spec_x = spec.x) === null || _spec_x === void 0 ? void 0 : _spec_x.key)) return false;
    if (spec.series == null || spec.series.length === 0) return false;
    if (spec.data == null || spec.data.length === 0) return false;
    return spec.series.some((series)=>seriesKeyInData(series.key, spec.data));
};
export const title = (spec)=>{
    var _spec_title;
    return (_spec_title = spec.title) !== null && _spec_title !== void 0 ? _spec_title : null;
};
export const resolvePieSeries = (spec)=>{
    var _spec_series_find;
    return (_spec_series_find = spec.series.find((series)=>seriesKeyInData(series.key, spec.data))) !== null && _spec_series_find !== void 0 ? _spec_series_find : spec.series[0];
};
export const effectiveStacked = (spec)=>spec.stacked === true && (spec.chart_type === 'bar' || spec.chart_type === 'area');
export const seriesColor = (index)=>SERIES_COLOR_RAMP[index % SERIES_COLOR_RAMP.length];
export const coerceSeriesValue = (raw)=>{
    if (raw == null) return null;
    if (typeof raw === 'number') return Number.isFinite(raw) ? raw : null;
    if (typeof raw !== 'string') return null;
    const trimmed = raw.trim();
    if (trimmed === '') return null;
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : null;
};
const timeOrder = (value)=>{
    const parsed = parseISO(String(value !== null && value !== void 0 ? value : '')).getTime();
    return Number.isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed;
};
const orderedRows = (spec)=>spec.x.type === 'time' ? [
        ...spec.data
    ].sort((a, b)=>timeOrder(a === null || a === void 0 ? void 0 : a[spec.x.key]) - timeOrder(b === null || b === void 0 ? void 0 : b[spec.x.key])) : spec.data;
const xLabel = (xValue, resolveByValue)=>{
    if (xValue == null) return '';
    const raw = String(xValue);
    if (resolveByValue == null) return raw;
    const resolution = resolveByValue(raw);
    return resolution.status === 'resolved' ? resolution.name : raw;
};
export const toRechartsData = (spec, resolveByValue)=>orderedRows(spec).map((row)=>{
        const datum = {
            [spec.x.key]: xLabel(row === null || row === void 0 ? void 0 : row[spec.x.key], resolveByValue)
        };
        spec.series.forEach((series)=>{
            datum[series.key] = coerceSeriesValue(row === null || row === void 0 ? void 0 : row[series.key]);
        });
        return datum;
    });
export const pieData = (spec, resolveByValue)=>{
    const seriesKey = resolvePieSeries(spec).key;
    return toRechartsData(spec, resolveByValue).filter((datum)=>datum[seriesKey] != null);
};
export const axisLabel = (x)=>{
    var _x_label;
    return (_x_label = x.label) !== null && _x_label !== void 0 ? _x_label : x.key;
};
export const seriesLabel = (series)=>{
    var _series_label;
    return (_series_label = series.label) !== null && _series_label !== void 0 ? _series_label : series.key;
};
export const formatTimeTick = (value)=>{
    const parsed = parseISO(value);
    return Number.isNaN(parsed.getTime()) ? value : formatShortMonthUSDate(parsed);
};
const MAX_TICK_LABEL_LENGTH = 16;
export const truncateTickLabel = (value)=>value.length <= MAX_TICK_LABEL_LENGTH ? value : "".concat(value.slice(0, MAX_TICK_LABEL_LENGTH - 1), "…");
